import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class PublicOrganizationParticipationParent extends List {
  constructor(obj) {
    super(PublicOrganizationParticipation, obj)
  }
}

export class PublicOrganizationParticipation {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.organization = obj?.organization || null
    this.organizationPlace = obj?.organizationPlace || null
    this.participationStatus = obj?.participationStatus || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      organization: this.organization,
      organizationPlace: this.organizationPlace,
      participationStatus: this.participationStatus
    }
  }
}
